import * as Yup from 'yup';

export const DataRoomItemSchema= Yup.object().shape({
    name: Yup.string()
    .min(1, 'Too Short!')
    .max(255, 'Too Long!')
    .required('f:validation.required')   
})     